// @ts-nocheck
/* eslint-enable */
/* eslint-disable camelcase */
import omit from 'lodash/omit';
import constants from 'app/shared/constants/ValueConstants';
import { areaUtils_getSrpMaxPageLimit } from 'app/shared/utils/areaUtils';
import queryUtils from 'app/shared/utils/queryUtils';

export const useMaxPageNumber = (totalBuildings, slug) => {
  const maxPage = Math.max(Math.ceil(totalBuildings / constants.MAX_LISTINGS_PER_PAGE), 1);

  return { maxPageNumber: areaUtils_getSrpMaxPageLimit(maxPage, slug) };
};

export const useMiddlePageNumbers = (currPageNum, totalPageNum, screenWidth) => {
  const middlePages = [];

  if (screenWidth === 'sm') {
    // Mobile logic (original)
    if (totalPageNum < 5) {
      for (let i = 2; i < totalPageNum; i++) {
        middlePages.push(i);
      }
    } else if (currPageNum === 1 || currPageNum === 2) {
      for (let i = 2; i < 4; i++) {
        middlePages.push(i);
      }
    } else if (currPageNum === totalPageNum || currPageNum === totalPageNum - 1) {
      for (let i = totalPageNum - 2; i < totalPageNum; i++) {
        middlePages.push(i);
      }
    } else {
      for (let i = currPageNum - 1; i < currPageNum + 2; i++) {
        middlePages.push(i);
      }
    }
  } else {
    // Desktop logic (from PagerContainer controller)
    if (totalPageNum < 7) {
      for (let i = 2; i < totalPageNum; i++) {
        middlePages.push(i);
      }
    } else if (currPageNum === 1 || currPageNum === 2 || currPageNum === 3 || currPageNum === 4) {
      for (let i = 2; i < 6; i++) {
        middlePages.push(i);
      }
    } else if (
      currPageNum === totalPageNum ||
      currPageNum === totalPageNum - 1 ||
      currPageNum === totalPageNum - 2 ||
      currPageNum === totalPageNum - 3
    ) {
      for (let i = totalPageNum - 5; i < totalPageNum; i++) {
        middlePages.push(i);
      }
    } else {
      for (let i = currPageNum - 2; i < currPageNum + 3; i++) {
        middlePages.push(i);
      }
    }
  }

  return { middlePages };
};

export const useMaxVisiblePageNumber = (currPageNum, totalPageNum) => {
  const paginationUpperBound = 20;
  const currFactorOfUpperBound = Math.ceil(currPageNum / paginationUpperBound);
  const upperBound = currFactorOfUpperBound * paginationUpperBound;

  if (totalPageNum < paginationUpperBound) {
    return { maxVisiblePageNumber: totalPageNum };
  }

  if (upperBound - currPageNum < 3) {
    const nextUpperBound = paginationUpperBound + upperBound;
    return { maxVisiblePageNumber: nextUpperBound > totalPageNum ? totalPageNum : nextUpperBound };
  }

  return { maxVisiblePageNumber: upperBound > totalPageNum ? totalPageNum : upperBound };
};

export const useLeftHandDots = (currPageNum, totalPageNum, screenWidth) => {
  if (screenWidth === 'sm') {
    return { showLeftHandDots: currPageNum > 3 && totalPageNum > 5 };
  } else {
    return { showLeftHandDots: currPageNum > 4 && totalPageNum > 6 };
  }
};

export const useRightHandDots = (currPageNum, totalPageNum, screenWidth) => {
  if (screenWidth === 'sm') {
    return { showRightHandDots: currPageNum < totalPageNum - 2 && totalPageNum > 5 };
  } else {
    return { showRightHandDots: currPageNum < totalPageNum - 3 && totalPageNum > 6 };
  }
};

export const useEdgePage = (page, maxPage) => {
  if (page - 1 === maxPage || page + 1 === 1) {
    return true;
  } else {
    return false;
  }
};

export const usePageLinks = () => {
  const getQuery = (page, query) => {
    // Only use query parameter page=n if n != 1 (because ?page=1 would be default url)
    let newQuery;
    if (page !== 1) {
      newQuery = Object.assign({}, query, {
        page,
      });
    } else {
      newQuery = omit(query, 'page');
    }

    return newQuery;
  };

  const makeLink = (page, query, url) => {
    if (page === '#') {
      return '#';
    }

    const newQuery = getQuery(page, query);

    return url + queryUtils.stringify(newQuery);
  };

  return [makeLink];
};
